export const USERS_PAGINATION = {
  page: 0,
  size: 10,
};

export const USERS_SORTING = {
  sortBy: "ID" as string | undefined,
  sortDir: "DESC" as "ASC" | "DESC" | undefined,
};

export const USER_STATUS_CONFIG: Record<string, { color: string; backgroundColor: string }> = {
  active: {
    color: "#1A9956",
    backgroundColor: "#D2F2E1",
  },
  blocked: {
    color: "#CA334D",
    backgroundColor: "#FFEDF0",
  },
  not_subscribed: {
    color: "#7F89AF",
    backgroundColor: "#F2F3F7",
  },
};

export const userDataIndexToColumnId: Record<string, string> = {
  id: "ID",
  username: "USERNAME",
  name: "NAME",
  surname: "SURNAME",
  role: "ROLE",
  createDate: "CREATION_DATE",
  state: "STATE",
};
